import React__default from 'react';
import { AccordionItem } from '@grandvisionhq/common';

const PrescriptionSection = ({ children , labels  })=>{
    return /*#__PURE__*/ React__default.createElement(React__default.Fragment, null, React__default.Children.map(children, (child)=>{
        if (!/*#__PURE__*/ React__default.isValidElement(child)) {
            return null;
        }
        if (child) {
            return /*#__PURE__*/ React__default.createElement(AccordionItem, {
                variant: "narrow",
                label: labels.prescription,
                id: labels.prescription
            }, child.props.children);
        }
        return null;
    }));
};

export { PrescriptionSection };
//# sourceMappingURL=PrescriptionSection.js.map
